var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h1", [_vm._v("定制主题")]),
      _vm._v(" "),
      _c("h3", [_vm._v("介绍")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "miVant 提供了一套默认主题，CSS 命名采用 BEM 的风格，方便使用者覆盖样式。如果你想完全替换主题色或者其他样式，可以使用下面提供的方法"
        )
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("样式变量")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("miVant 使用了 "),
        _c("a", { attrs: { href: "http://lesscss.org/" } }, [_vm._v("Less")]),
        _vm._v(
          " 对样式进行预处理，并内置了一些样式变量，通过替换样式变量即可定制你自己需要的主题。"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("下面是一些基本的样式变量，所有可用的颜色变量请参考 "),
        _c(
          "a",
          {
            attrs: {
              href: "https://github.com/youzan/vant/blob/dev/src/style/var.less"
            }
          },
          [_vm._v("配置文件")]
        ),
        _vm._v("。")
      ]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c("code", { attrs: { "v-pre": "", class: "language-less" } }, [
          _c("span", { attrs: { class: "hljs-attribute" } }, [
            _vm._v("@primary-btn-color ")
          ]),
          _vm._v(":"),
          _c("span", { attrs: { class: "hljs-number" } }, [_vm._v("#fbb212")]),
          _vm._v(";\n")
        ])
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("定制方法")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [
          _c("p", [
            _vm._v("使用 less 提供的 "),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "http://lesscss.org/usage/#using-less-in-the-browser-modify-variables"
                }
              },
              [_vm._v("modifyVars")]
            ),
            _vm._v(" 即可对变量进行修改，下面是参考的 webpack 配置。")
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("p", [_vm._v("这里以vue2.x版本的脚手架举例  /build/utils目录下")])
        ])
      ]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c("code", { attrs: { "v-pre": "", class: "language-js" } }, [
          _vm._v("exports.cssLoaders = "),
          _c("span", { attrs: { class: "hljs-function" } }, [
            _c("span", { attrs: { class: "hljs-keyword" } }, [
              _vm._v("function")
            ]),
            _vm._v(" ("),
            _c("span", { attrs: { class: "hljs-params" } }, [
              _vm._v("options")
            ]),
            _vm._v(") ")
          ]),
          _vm._v("{\n  options = options || {}\n\n  "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("const")]),
          _vm._v(" lessLoader = {\n    "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("loader")]),
          _vm._v(": "),
          _c("span", { attrs: { class: "hljs-string" } }, [
            _vm._v("'less-loader'")
          ]),
          _vm._v(",\n    "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("options")]),
          _vm._v(": {\n      "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("sourceMap")]),
          _vm._v(": options.sourceMap,\n      "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("modifyVars")]),
          _vm._v(": {\n        "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("color")]),
          _vm._v(": "),
          _c("span", { attrs: { class: "hljs-string" } }, [_vm._v("'red'")]),
          _vm._v("\n      }\n    }\n  }\n  "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("const")]),
          _vm._v(" lessConfig = {\n    "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("modifyVars")]),
          _vm._v(": {\n      primary-btn-color: "),
          _c("span", { attrs: { class: "hljs-string" } }, [_vm._v("'red'")]),
          _vm._v("\n    }\n  };\n\n\n  "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("const")]),
          _vm._v(" cssLoader = {\n    "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("loader")]),
          _vm._v(": "),
          _c("span", { attrs: { class: "hljs-string" } }, [
            _vm._v("'css-loader'")
          ]),
          _vm._v(",\n    "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("options")]),
          _vm._v(": {\n      "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("sourceMap")]),
          _vm._v(": options.sourceMap\n    }\n  }\n\n  "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("const")]),
          _vm._v(" postcssLoader = {\n    "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("loader")]),
          _vm._v(": "),
          _c("span", { attrs: { class: "hljs-string" } }, [
            _vm._v("'postcss-loader'")
          ]),
          _vm._v(",\n    "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("options")]),
          _vm._v(": {\n      "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("sourceMap")]),
          _vm._v(": options.sourceMap\n    }\n  }\n\n  "),
          _c("span", { attrs: { class: "hljs-comment" } }, [
            _vm._v(
              "// generate loader string to be used with extract text plugin"
            )
          ]),
          _vm._v("\n  "),
          _c("span", { attrs: { class: "hljs-function" } }, [
            _c("span", { attrs: { class: "hljs-keyword" } }, [
              _vm._v("function")
            ]),
            _vm._v(" "),
            _c("span", { attrs: { class: "hljs-title" } }, [
              _vm._v("generateLoaders")
            ]),
            _vm._v("("),
            _c("span", { attrs: { class: "hljs-params" } }, [
              _vm._v("loader, loaderOptions")
            ]),
            _vm._v(") ")
          ]),
          _vm._v("{\n    "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("const")]),
          _vm._v(
            " loaders = options.usePostCSS ? [cssLoader, postcssLoader, lessLoader] : [cssLoader, lessLoader]\n\n    "
          ),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("if")]),
          _vm._v(" (loader) {\n      loaders.push({\n        "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("loader")]),
          _vm._v(": loader + "),
          _c("span", { attrs: { class: "hljs-string" } }, [
            _vm._v("'-loader'")
          ]),
          _vm._v(",\n        "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("options")]),
          _vm._v(": "),
          _c("span", { attrs: { class: "hljs-built_in" } }, [_vm._v("Object")]),
          _vm._v(".assign({}, loaderOptions, {\n          "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("sourceMap")]),
          _vm._v(": options.sourceMap\n        })\n      })\n    }\n\n    "),
          _c("span", { attrs: { class: "hljs-comment" } }, [
            _vm._v("// Extract CSS when that option is specified")
          ]),
          _vm._v("\n    "),
          _c("span", { attrs: { class: "hljs-comment" } }, [
            _vm._v("// (which is the case during production build)")
          ]),
          _vm._v("\n    "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("if")]),
          _vm._v(" (options.extract) {\n      "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("return")]),
          _vm._v(" ExtractTextPlugin.extract({\n        "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("use")]),
          _vm._v(": loaders,\n        "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("fallback")]),
          _vm._v(": "),
          _c("span", { attrs: { class: "hljs-string" } }, [
            _vm._v("'vue-style-loader'")
          ]),
          _vm._v("\n      })\n    } "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("else")]),
          _vm._v(" {\n      "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("return")]),
          _vm._v(" ["),
          _c("span", { attrs: { class: "hljs-string" } }, [
            _vm._v("'vue-style-loader'")
          ]),
          _vm._v("].concat(loaders)\n    }\n  }\n\n  "),
          _c("span", { attrs: { class: "hljs-comment" } }, [
            _vm._v(
              "// https://vue-loader.vuejs.org/en/configurations/extract-css.html"
            )
          ]),
          _vm._v("\n  "),
          _c("span", { attrs: { class: "hljs-keyword" } }, [_vm._v("return")]),
          _vm._v(" {\n    "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("css")]),
          _vm._v(": generateLoaders(),\n    "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("postcss")]),
          _vm._v(": generateLoaders(),\n    "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("less")]),
          _vm._v(": generateLoaders("),
          _c("span", { attrs: { class: "hljs-string" } }, [_vm._v("'less'")]),
          _vm._v(", lessConfig),\n    "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("sass")]),
          _vm._v(": generateLoaders("),
          _c("span", { attrs: { class: "hljs-string" } }, [_vm._v("'sass'")]),
          _vm._v(", { "),
          _c("span", { attrs: { class: "hljs-attr" } }, [
            _vm._v("indentedSyntax")
          ]),
          _vm._v(": "),
          _c("span", { attrs: { class: "hljs-literal" } }, [_vm._v("true")]),
          _vm._v(" }),\n    "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("scss")]),
          _vm._v(": generateLoaders("),
          _c("span", { attrs: { class: "hljs-string" } }, [_vm._v("'sass'")]),
          _vm._v("),\n    "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("stylus")]),
          _vm._v(": generateLoaders("),
          _c("span", { attrs: { class: "hljs-string" } }, [_vm._v("'stylus'")]),
          _vm._v("),\n    "),
          _c("span", { attrs: { class: "hljs-attr" } }, [_vm._v("styl")]),
          _vm._v(": generateLoaders("),
          _c("span", { attrs: { class: "hljs-string" } }, [_vm._v("'stylus'")]),
          _vm._v(")\n  }\n}\n")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib!./node_modules/vue-markdown-loader/lib/markdown-compiler.js??ref--1-1!./docs/customTheme.md?vue&type=template&id=0cd6490b&
// module id = null
// module chunks = 